import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      filter: ({ filtersStore: { filter } }) => filter,
      queries: ({ resourcesStore: { queries } }) => queries,
  }),
},
methods: {
    deactivate(type, name, resourceId) {
        let updateQuery = JSON.parse(JSON.stringify(this.queries.videos));
        if(type === 'products' && updateQuery.filters.products){
            updateQuery.sort = {
                'recommended_at': 'desc', 
            }
            delete updateQuery.filters.products;
        }
        if(type === 'products' && updateQuery.filters.recurring_from){
            updateQuery.sort = {
                'recommended_at': 'desc', 
            }
            delete updateQuery.filters.recurring_from;
        }
        if(type === 'models' && updateQuery.filters.resources || type === 'categories' && updateQuery.filters.resources) {
          const updatedResources = Object.values(updateQuery.filters.resources)
          .filter((id) => id !== resourceId)
          .reduce((acc, id, index) => {
              acc[index] = id;
              return acc;
          }, {});
          if (Object.keys(updatedResources).length === 0) {
            const { resources, ...remainingFilters } = updateQuery.filters;
            updateQuery.filters = remainingFilters;
        } else {
            updateQuery.filters = {
              ...updateQuery.filters,
              resources: updatedResources,
          };
      }
  }
  if(type === 'language'){
    delete updateQuery.filters.language;
}
updateQuery.pagination.page = 1;
this.$store.commit('filtersStore/reset', type);
this.$store.commit('resourcesStore/updateQuery', updateQuery);
this.$store.dispatch('resourcesStore/getResources', this.queries.videos);
},
}
}